import { gql } from '@apollo/client';

export const GENERATE_TINY_URL_AND_TOKEN = gql`
  mutation ($data: GenerateTinyUrlAndTokenInput!) {
    generateTinyUrlAndToken(data: $data)
  }
`;

const GET_PAYMENT_METHODS_FRAGMENT = gql`
  fragment PaymentMethodSelection on StripePaymentMethod {
    id
    last4
    cardBrand
    expirationMonth
    expirationYear
    stripeId
    stripeCustomerId
    isExpired
    isReusable
    isDefault
    funding
  }
`;

export const GET_PAYMENT_METHODS = gql`
  query findManyStripePaymentMethod($where: StripePaymentMethodWhereInput!) {
    findManyStripePaymentMethod(where: $where) {
      ...PaymentMethodSelection
    }
  }
  ${GET_PAYMENT_METHODS_FRAGMENT}
`;

export const UPDATE_ONE_PAYMENT_METHOD = gql`
  mutation updateOneStripePaymentMethod(
    $where: StripePaymentMethodWhereUniqueInput!
    $data: StripePaymentMethodUpdateInput!
  ) {
    updateOneStripePaymentMethod(where: $where, data: $data) {
      ...PaymentMethodSelection
    }
  }
  ${GET_PAYMENT_METHODS_FRAGMENT}
`;

export const UPDATE_CLINIC_FINANCIAL_REPORT_SETTINGS = gql`
  mutation updateClinicSettingTransactionColumn(
    $data: ClinicSettingUpdateInput!
    $where: ClinicSettingWhereUniqueInput!
  ) {
    updateClinicSettingTransactionColumn(data: $data, where: $where) {
      id
    }
  }
`;

export const CREATE_ONE_CALL_HISTORY = gql`
  mutation createOneCallHistory($data: CallHistoryCreateInput!) {
    createOneCallHistory(data: $data) {
      id
      sourceId
      from
      provider
      type
      status
      clinic {
        name
      }
    }
  }
`;

export const UPDATE_ONE_CALL_HISTORY = gql`
  mutation updateOneCallHistory($where: CallHistoryWhereUniqueInput!, $data: CallHistoryUpdateInput!) {
    updateOneCallHistory(where: $where, data: $data) {
      status
      duration
    }
  }
`;

export const CREATE_ONE_CALL_PARTICIPANT = gql`
  mutation createOneCallParticipant($data: CallParticipantCreateInput!) {
    createOneCallParticipant(data: $data) {
      id
      number
      user {
        id
      }
      clinicPetParent {
        id
      }
      callHistory {
        id
      }
    }
  }
`;

export const CREATE_OFFICE_HOURS = gql`
  mutation createAutomationHours($id: String, $officeHours: [ClinicOfficeHourCreateWithoutClinicInput!]) {
    updateOneClinic(where: { id: $id }, data: { clinicOfficeHours: { create: $officeHours } }) {
      id
      clinicOfficeHours {
        id
        dayOfWeek
        openAt
        closeAt
        isEnabled
        isOpenTwentyFourHours
        type
      }
    }
  }
`;
